   
export const SUMMARY_FIELDS = [
  { key: "Item_Code", label: "รหัสสินค้า", w: "12%", alignHeader: "center", align: "center", numeric: false, sortable: true },
  { key: "Item_Name", label: "ชื่อสินค้า", w: "20%", alignHeader: "center", align: "left", numeric: false, sortable: true },
  { key: "total_customer", label: "ลูกค้า (ราย)", w: "8%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "total_customer_repeat", label: "ลูกค้าซื้อซ้ำ (ราย)", w: "8%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "repeat_rate", label: "อัตราซื้อซ้ำ (%)", w: "8%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "TotalQty", label: "จำนวนที่ขาย (ชิ้น)", w: "8%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "Item_Total", label: "ยอดรวม (บาท)", w: "8%", alignHeader: "end", align: "end", numeric: true, sortable: true },

];

export const DETAIL_FIELDS = [
    {
        key: "Doc_Date",
        label: "วันที่",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Doc_No",
        label: "เลขที่เอกสาร",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "AR_Code",
        label: "รหัสลูกค้า",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },

        {
        key: "AR_Name",
        label: "ชื่อลูกค้า",
        w: "16%",
        alignHeader: "center",
        align: "left",
        numeric: false,
        sortable: true,
    },
     
    {
        key: "Item_Qty",
        label: "จำนวนที่ซื้อ",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Price_Unit",
        label: "ราคาต่อหน่วย",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Discount",
        label: "ส่วนลด",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Total",
        label: "ยอดรวม",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    }
    
];
